import clsx from 'clsx'
import React from 'react'

import s from './styles.module.scss'

import { IconSvg } from '../../../../../components/atoms/icons'

export const TagAvailableSoon = ({
  className = '',
  label = 'Bientôt sur Naboo',
  hideIcon = false,
}: {
  className?: string
  label?: string
  hideIcon?: boolean
}) => {
  return (
    <div className={clsx(s.cardTag, s.availableSoon, className)}>
      {!hideIcon && <IconSvg.Star className={s.iconStar} />}
      <span className={s.cardTagLabel}>{label} </span>
    </div>
  )
}
